export default __webpack_public_path__ + "static/media/element_spec_64.fab7f340.jpg";